import React from "react";
import styled, { useTheme } from "styled-components";

import { ModalProps } from "./types";
import Button from "../../atoms/Button";

const Modal = ({
  isOpen,
  handleClose,
  text,
  buttonText,
  onButtonClick,
  buttonColor,
}: ModalProps) => {
  const theme = useTheme();

  return isOpen ? (
    <StyledModalWrapper>
      <StyledModal>
        <p>{text}</p>

        <Button
          text={buttonText}
          onClick={onButtonClick}
          width="fit-content"
          backgroundColor={buttonColor}
          color={theme.colors.text}
        />
      </StyledModal>

      <StyledBackdrop onClick={handleClose} />
    </StyledModalWrapper>
  ) : null;
};

const StyledModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const StyledModal = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.text};
  border-radius: ${({ theme }) => theme.radii.default};
  width: 88%;
  max-width: 400px;
  color: ${({ theme }) => theme.colors.dark};
  z-index: 1000;
  padding: 15px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: column;
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

const StyledBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.2;
  z-index: 999;
`;

export default Modal;
